<template>
  <div class="table-filter" :style="{ display: isVisible ? 'block' : 'none' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TableFilter",
  props: ['toggleButton'],
  data() {
    return {
      isVisible: false
    }
  },
  mounted: function() {
    const self = this;
    window.$(this.toggleButton).on('click', function() {
      window.$('.table-filter-wrapper').toggleClass('table-filter-show');
      setTimeout(function(){
        const hasShowClass = window.$('.table-filter-wrapper').hasClass('table-filter-show');
        self.isVisible = hasShowClass;
      }, 250);
      window.$('body').toggleClass('sidebar-collapse');
    });
  }
};
</script>